module.exports = __webpack_public_path__ + "img/camping-pass.523ddcda.svg";